<template>
  <transition name="modal">
    <div class="modal-mask" tabindex="-1" role="dialog" aria-hidden="true" @click="$emit('closed')">
      <div class="modal-dialog" v-bind:class="classes" role="document" @click.stop style="width:100%">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="title"></slot>
            <button type="button" class="close" @click="$emit('closed')" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  props: ['showing', 'centered', 'size'],
  mounted() {
    let that = this;

    document.addEventListener('keydown', function (event) {
      if (event.keyCode === 27) {
        that.$emit('closed');
      }
    });
  },

  computed: {
    classes() {
      return {
        'modal-dialog-centered': this.centered,
        'modal-lg': this.size == 'large',
        'modal-sm': this.size == 'small'
      }
    }
  }
}

</script>
